import {
    SET_ASSET_ITEM_STATUS_PURCHASE_DETAILS,
    SET_IS_ASSET_ITEM_STATUS_PURCHASE_DETAILS_CALLED
} from "./AssetItemStatusPurchaseDetailType"


const initialState = {
    assetItemStatusPurchaseDetails: [],
    loadingStates: {} as any 
}


const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_ASSET_ITEM_STATUS_PURCHASE_DETAILS:
            return {
                ...state,
                assetItemStatusPurchaseDetails: action.assetItemStatusPurchaseDetails
            };
        case SET_IS_ASSET_ITEM_STATUS_PURCHASE_DETAILS_CALLED:
            const { fleetDetailId, isLoading } = action;
            return {
              ...state,
              loadingStates: {
                ...state.loadingStates,
                [fleetDetailId]: {
                  ...state.loadingStates[fleetDetailId],
                  isLoading: isLoading
                }
              }
            };
        default:
            return state;
    }
};

export default reducer;